<template>
  <div id="studentinfo">
    <div class="cardinfo">
      <a-card class="box-card" :bordered="false" style="width: 300px">
        <p>
          <a-icon class="icon" type="user" />
          姓名：{{stuinfo.name}}
        </p>
        <p>
          <a-icon class="icon" type="reconciliation" />
          <!-- <a-icon class="icon" type="tags" /> -->
          单位：{{stuinfo.universityId_dictText}}
        </p>
        <p>
          <a-icon class="icon" type="highlight" />
          部门：{{stuinfo.departmentId_dictText}}
        </p>
        <p>
          <a-icon class="icon" type="read" />
          学号：{{stuinfo.studentNo}}
        </p>
      </a-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Studentinfo",
  props:["stuinfo"],
  data() {
    return {
      name: "",
      university: "",
      department: "",
      studentNo: 0,
    };
  },
  mounted(){
    // console.log(this.stuinfo);
  },
  methods: {},
};
</script>
<style scoped>
.cardinfo {
  box-sizing: border-box;
  padding: 2vh;
  margin-top: 1vh;
  text-align: left;
  /* border: 1px dashed black; */
  margin-bottom: 3vh;
}
.cardinfo .box-card {
  box-sizing: border-box;
  padding-left: 1vw;
  line-height: 20px;
  width: 100% !important;
  /* margin-right: 0; */
  border-radius: 1vw;
  background-color: blueviolet;
  color: white;
}
.icon{
    margin-right: 1vw;
}
@media screen and (max-width: 768px) {
  .cardinfo {
  box-sizing: border-box;
  padding: 1vh;
  margin-top: 1vh;
  text-align: left;
  /* border: 1px dashed black; */
  margin-bottom: 3vh;
}
.cardinfo .box-card {
  box-sizing: border-box;
  padding-left: 1vw;
  line-height: 20px;
  width: 100% !important;
  /* margin-right: 0; */
  border-radius: 2vw;
  background-color: blueviolet;
  color: white;
}
.icon{
    margin-right: 1vw;
}
}
</style>


// WEBPACK FOOTER //
// src/components/Studentinfo/Studentinfo.vue